<div
  class="ui container"
  appMargin
  appPadding
  paddingB="30"
  style="padding-left: 0; padding-right: 0"
>
  <div class="ui vertical basic segment">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div
        fxLayoutAlign="start center"
        fxLayout="row"
        fxLayoutGap="20px"
        class="link"
      >
        <div class="equipment-id">
          <!-- Title -->
          <h2 class="ui primary header">Chat with NCC</h2>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px"></div>
    </div>
    <div class="ui divider" appMargin marginY="3"></div>
  </div>
  <div>
    <h5 class="ui center aligned header">
      {{ session?.subtopic?.topic.topic }}
      <div class="sub header">{{ session?.subtopic?.subtopic }}</div>
    </h5>
    <div class="ui divider" appMargin marginY="3"></div>
    <div *ngIf="success || error" appMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>
  </div>

  <div
    class="scroll-wrapper ui basic segment"
    style="padding-left: 0; padding-right: 0"
    *ngIf="!chatClosed"
  >
    <div
      #scrollContainer
      id="scrollMe"
      infinite-scroll
      [scrollWindow]="true"
      [infiniteScrollUpDistance]="2"
      (scrolled)="onScrollDown($event)"
      (scrolledUp)="onScrollUp($event)"
      appPadding="0"
      class="scroll-wrapper ui basic segment"
      style="
        height: 36vh;
        overflow-y: scroll;
        padding-left: 0;
        padding-right: 0;
      "
    >
      <!-- current chat messages -->
      <div class="hide-scroll">
        <div
          class="scroll-wrapper ui basic segment"
          style="padding-left: 0; padding-right: 0"
          [ngClass]="{ loading: pending }"
        >
          <div *ngIf="!isReply" class="chat-info">
            <p *ngIf="messages.length > 0">Live Chat Started</p>
          </div>
          <div
            *ngFor="let comment of messages; let idx = index"
            class="chat-element"
          >
            <!-- shows time comment was made -->
            <div *ngIf="!isReply" class="chat-info">
              <div
                class="comment-date"
                style="margin-bottom: 14px !important; display: inline-flex"
                *ngIf="
                  (comment?.dateCreated | date: 'd MMM y') !==
                  (messages[idx - 1]?.dateCreated | date: 'd MMM y')
                "
              >
                {{ comment?.dateCreated | date: "d MMM y" }}
              </div>
              <!-- <p>Musa - NCC joined live chat</p>
              <p style="margin-bottom: 14px !important;" >Messages are being watched by NCC Admin Staff</p> -->
            </div>
            <!-- add to check if user is not current user is typing -->
            <div>
              <app-chat-messages
                [message]="comment"
                [index]="idx"
                [messages]="messages"
                [userEmail]="userEmail"
                (reply)="onReply($event)"
              ></app-chat-messages>
            </div>
            <!-- <app-chat-messages
              [msg]="comment"
              (reply)="onReply($event)"
            ></app-chat-messages> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container_reply">
    <div
      appPadding="0px"
      appMargin
      marginX="30px"
      marginT="20px"
      class="ui basic segment"
      *ngIf="!chatClosed && isReply"
    >
      <div appPadding="0px" class="ui basic segment" id="reply-block">
        <div
          class="ui circular red tiny right floating label clickable"
          (click)="removeReply()"
        >
          <i appMargin="0px" class="cancel icon"></i>
        </div>
        <div appMargin="0px" class="ui segment">
          <app-chat-messages
            [userEmail]="userEmail"
            isReply="true"
            [message]="isReply"
          >
          </app-chat-messages>
        </div>
      </div>
      <div class="ui form" [formGroup]="replyForm">
        <div
          class="field"
          fxLayout="row"
          fxLayoutGap="3px"
          fxLayoutAlign="space-between end"
        >
          <div class="field" fxFlex="grow">
            <textarea
              class="content-area"
              formControlName="comment"
              placeholder="Write a message"
              rows="3"
              style="resize: none"
            >
Write a message</textarea
            >
          </div>
        </div>
        <!-- attachment shown if added -->
        <div>
          <div
            class="ui image fluid primary label"
            *ngIf="fileObj"
            appMargin
            marginB="10px"
          >
            Attachment:
            <span>{{ fileName }}</span>
            <i
              class="delete icon"
              (click)="removeFile()"
              style="float: right"
              suiPopup
              popupPlacement="top"
              popupText="remove attachment"
            ></i>
          </div>
          <!-- <div appMargin marginY="10px" *ngIf="">
              <sui-message class="info" [isDismissable]="false">
                <p>You may attach only one file at a time!</p>
                <p>please remove previous attachment first to make a new selection</p>
              </sui-message>
            </div> -->
        </div>

        <div
          class="field"
          fxLayout="row"
          fxLayoutGap="3px"
          fxLayoutAlign="space-between center"
        >
          <div fxFlex="10%">
            <button class="ui tiny icon button" (click)="uploader.click()">
              <i class="file large outline icon"></i>
            </button>

            <input
              hidden
              type="file"
              accept=".jpg, .jpeg, .png, .pdf,.xlsx,.docx"
              #uploader
              (change)="uploadDoc($event.target.files)"
              placeholder="Browse for documents"
              onclick="value = null"
            />
          </div>

          <div fxFlex class="text-right">
            <button
              class="ui tiny primary button"
              [disabled]="!replyForm.valid || pending"
              (click)="send(isReply.messageId)"
            >
              Send
            </button>
            <!-- <button class="ui tiny icon button">
							<i class="ellipsis vertical icon"></i>
						</button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- not a reply form -->
    <div
      *ngIf="!chatClosed && !isReply"
      appMargin
      marginT="10"
      class="ui form"
      [formGroup]="replyForm"
    >
      <div
        class="field"
        fxLayout="row"
        fxLayoutGap="3px"
        fxLayoutAlign="space-between end"
      >
        <div class="field" fxFlex="grow">
          <textarea
            class="content-area"
            formControlName="comment"
            placeholder="Write a message"
            rows="3"
            style="resize: none"
          >
Write a message</textarea
          >
        </div>
      </div>

      <!-- attachment shown if added -->
      <div
        *ngIf="fileObj"
        class="ui image fluid primary label"
        appMargin
        marginB="10px"
      >
        Attachment:
        <span>{{ fileName }}</span>
        <i
          class="delete icon"
          (click)="removeFile()"
          style="float: right"
          suiPopup
          popupPlacement="top"
          popupText="remove attachment"
        ></i>
      </div>

      <!-- <div appMargin marginY="10px" *ngIf="checkAttach()">
				<sui-message class="info" [isDismissable]="false">
          <p>You may attach only one file at a time!</p>
          <p>please remove previous attachment first to make a new selection</p>
        </sui-message>
      </div> -->

      <div
        class="field"
        fxLayout="row"
        fxLayoutGap="8px"
        fxLayoutAlign="space-between center"
      >
        <div fxFlex="10%">
          <button class="ui tiny icon button" (click)="uploader.click()">
            <i class="file large outline icon"></i>
          </button>

          <input
            hidden
            type="file"
            accept=".jpg, .jpeg, .png, .pdf,.xlsx,.docx"
            #uploader
            (change)="uploadDoc($event.target.files)"
            placeholder="Browse for documents"
            onclick="value = null"
          />
        </div>

        <div fxFlex class="text-right">
          <button
            class="ui tiny primary button"
            [disabled]="!replyForm.valid || pending"
            (click)="send('null')"
          >
            Send
          </button>
          <!-- <button class="ui tiny icon button">
											<i class="ellipsis  vertical icon"></i>
											</button> -->
        </div>
      </div>
    </div>

    <div *ngIf="chatClosed" class="ui segment closed_chat">
      <img
        alt="closed chat"
        src="../../../../../assets/images/closed-chat.png"
      />
      <div class="closed_chat_text">
        <p>This Chat link is expired and the chat is closed.</p>
        <p>Please contact NCC through the website for further discussion.</p>
      </div>
    </div>
  </div>
</div>
